import RootErrorBoundary from '@/components/organism/RootErrorBoundary';
import RootSuspense from '@/components/organism/RootSuspense';
import { Outlet } from 'react-router-dom';

const ProtectedPublicRoute = () => {
  return (
    <RootErrorBoundary>
      <RootSuspense>
        <Outlet />
      </RootSuspense>
    </RootErrorBoundary>
  );
};

export default ProtectedPublicRoute;
